export default __webpack_public_path__ + "static/media/program-main-v2.79f99000.jpg";